module.exports = {
      id: "ai-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#ai",
      toString: function () {
        return this.url;
      }
    }